import { default as Container } from './GroupAbout.container';
import { default as Component } from './GroupAbout';
export default Container(Component);
